export default __webpack_public_path__ + "static/media/CLYBYMATTHEW_20230318_0168_FC1_0001_tn.c9c998bb.jpg";